import React, { useEffect, useRef } from 'react'
import type { NextPage } from 'next'
import { useRouter } from 'next/router'
import Head from 'next/head'
import Footer from 'src/components/Footer'
import Loading from 'src/components/Loading'
import NotFound from 'src/components/NotFound';
import Loaded from 'src/components/Loaded'
import CriticalError from 'src/components/CriticalError'
import { Center, Box } from 'src/theme'
import {
  RedemptionProvider,
  useRedemptionMachine,
  RedemptionError,
} from '@dapperlabs/redeem.js';
import { captureException } from 'src/lib/sentry';
import { IdentifyUser } from 'src/components/IdentifyUser';
import { AnalyticsTracker } from 'src/components/AnalyticsTracker'
import { maintenanceWrapper } from 'src/lib/maintenance'
import { compileUrl } from '@dapperlabs/redeem.js'


const RedeemPresenter = () => {
  const [current] = useRedemptionMachine()
  const timeoutRef = useRef<ReturnType<typeof setInterval>>()

  // if a target url is ever present on the campaign and the user got this far
  // we redirect them to the targetUrl as they shouldn't be here
  useEffect(() => {
    if (current.context.campaign?.targetUrl && !timeoutRef.current) {
      timeoutRef.current = setTimeout(() => {
        const targetUrl = compileUrl(current.context.campaign.targetUrl, { code: current.context.code });
        window.location.href = targetUrl
      }, 1500);
    }
    return () => {
      clearTimeout(timeoutRef.current)
    }
  }, [current.context.campaign?.targetUrl, current.context.code])

  const title = current.context.campaign
    ? `Dapper Labs - Redeem - ${current.context.campaign.name}`
    : `Dapper Labs - Redeem`
  return (
    <Center minH='100vh' bg='black' flexDir='column'>
      <Head>
        <title>{title}</title>
        <meta name="description" content="Dapper Labs - NFT Redemption" />
        <link rel="icon" href="/favicon.png" />
      </Head>
      <Box
        maxW='sm'
        minW='sm'
        borderWidth='1px'
        borderRadius='lg'
        overflow='hidden'
        
        boxShadow='md'
      >
        {(() => {
          switch (true) {
            case current.matches('LOADING'):
              return <Loading />
            case current.matches('ERROR'):
              return <CriticalError />
            case current.matches('NOT_FOUND'):
              return <NotFound />
            default:
              return <Loaded />
          }
        })()}
      </Box>
      {/* <Footer /> */}
    </Center>
  )
}

function handleRedemptionError (e) {
  try {
    let opts = {}
    if (e instanceof RedemptionError) {
      opts = {
        errorInfo: {
          originalError: e.originalMessage,
        },
      }
    }
    captureException(e, opts)
  } catch (e) {
    // swallow if fail
  }
}

const Redeem: NextPage = (props) => {
  const { query } = useRouter()
  if (!query.code) return null
  return (
    <RedemptionProvider
      onError={handleRedemptionError}
      code={query.code as string}
      apiUrl='/api/proxy'
    >
      <IdentifyUser />
      <AnalyticsTracker />
      <RedeemPresenter />
    </RedemptionProvider>
  )
}

export default Redeem

export const getServerSideProps = maintenanceWrapper(async () => ({ props: {} }))
